module.exports = __webpack_public_path__ + "news-4a753f38/503-4047d3143a02e6fe213c64b20551cbdf.svg";